<template>
  <div class="user-management-id-auth main-second-bg clearfix">
    <p class="user-management-child-header b-1-cl a-3-bd">
      {{ $t("personal.idAuth.title") }}
    </p>
    <div v-if="kycType === '1' && appAuthOpen" class="goAppAuth main-second-bg">
      <div class="goAppAuthNote">{{ $t("personal.idAuth.step1") }}</div>
      <div class="qrCode" v-if="appDownload.app_page_url">
        <img :src="appDownload.app_page_url" alt="" />
        <div>{{ $t("personal.idAuth.appDownLoad") }}</div>
      </div>
      <div class="goAppAuthNote">{{ $t("personal.idAuth.step2") }}</div>
      <div class="exImg">
        <img src="https://saas-oss.oss-accelerate.aliyuncs.com/upload/20200805194924641.png" />
      </div>
    </div>
    <div class="user-management-center main-second-bg" v-else>
      <div class="certification-process">
        <div class="div-line gray-bd clearfix"></div>
        <div class="step-left main-second-bg">
          <p :class="this.activeP1">
            <span :class="active==='1'?'blue-bg white-cl':''" class="span-mark gray-30-bg clearfix">1</span>
            {{ $t("personal.idAuth.info") }}
          </p>
        </div>
        <div class="step-center main-second-bg">
          <p :class="this.activeP2">
            <span :class="active==='2'?'blue-bg white-cl':''" class="span-mark gray-30-bg clearfix">2</span>
            {{ $t("personal.idAuth.uploadDocuments") }}
          </p>
        </div>
        <div class="step-right main-second-bg">
          <p :class="this.activeP3">
            <span :class="active==='3'?'blue-bg white-cl':''" class="span-mark gray-30-bg clearfix">3</span>
            {{ $t("personal.idAuth.submitted") }}
          </p>
        </div>
      </div>
      <div class="idAuth-center clearfix">
        <div class="activeOne" v-if="active === '1'">
          <div class="upload-text1 red-cl clearfix">
            <!-- 1、认证信息一经验证不可修改，请务必如实填写 -->
            <p>
              <!-- <svg-icon class="icon icon-14" icon-class="warningIcon"></svg-icon> -->
              <span v-if="$t('personal.kyc.text2').trim()">1、</span>
              {{ $t("personal.kyc.text1") }}
            </p>
            <!-- 2、被认证的实名信息不能重复认证 -->
            <p v-if="$t('personal.kyc.text2').trim().length">
              2、{{ $t("personal.kyc.text2") }}
            </p>
          </div>
          <!-- 国家或地区 -->
          <c-inputLine
            :promptText="$t('personal.kyc.areaTitle')"
            :value="kycNationality"
            :disabled="true"
            :errorHave="true"
            newStyleFormat
          />
          <!-- 证件类型 -- 中国 -->
          <!-- <c-inputLine
            v-if="kycType === '1'"
            :promptText="$t('personal.kyc.type')"
            :value="$t('personal.label.idCard')"
            :disabled="true"
            :errorHave="true"
          /> -->
          <!-- 证件类型 -- 外国 -->
          <!-- v-if="kycType === '2'" -->
          <!-- 证件类型1 -->
          <c-select
            :value="certificateType1"
            :promptText="certificateType1PromptText"
            @onChanges="certificateType1Change"
            name="certificateType1"
            :errorHave="true"
            :errorFlag="certificateTypeErrorFlag"
            :options="certificateType1Options"
            newStyleFormat
            style="margin-bottom: 36px;"
          />
          <c-inputLine
            name="certificateType1Value"
            v-if="certificateType1"
            :promptText="certificateType1NumPromptText"
            :value="certificateType1Value"
            :errorHave="true"
            @onchanges="certificateTypeInputChange"
            newStyleFormat
          />
          <!-- 证件类型2 -->
          <c-select
            :value="certificateType2"
            :promptText="certificateType2PromptText"
            @onChanges="certificateType2Change"
            name="certificateType2"
            :errorHave="true"
            :errorFlag="certificateTypeErrorFlag"
            :options="certificateType2Options"
            newStyleFormat
            style="margin-bottom: 36px;"
          />
          <c-inputLine
            name="certificateType2Value"
            v-if="certificateType2"
            :promptText="certificateType2NumPromptText"
            :value="certificateType2Value"
            :errorHave="true"
            @onchanges="certificateTypeInputChange"
            newStyleFormat
          />

          <!-- 中国 - 姓名 -->
          <!-- <c-inputLine
            v-if="kycType === '1'"
            maxLength="50"
            name="name"
            inputType="text"
            :promptText="promptText2"
            :errorHave="true"
            marginTop="0px"
            :value="checkValue2"
            @onchanges="inputChanges"
          /> -->
          <!-- 外国 - 名 -->
          <c-inputLine
            maxLength="50"
            name="kycName"
            :promptText="name"
            :errorHave="true"
            :value="kycName"
            @onchanges="inputChanges"
            newStyleFormat
          />
          <!-- 外国 - 姓 -->
          <c-inputLine
            maxLength="50"
            name="kycFamilyName"
            :promptText="fName"
            :errorHave="true"
            :value="kycFamilyName"
            @onchanges="inputChanges"
            newStyleFormat
          />
          <c-inputLine
            name="address"
            maxLength="35"
            inputType="text"
            :promptText="promptText1"
            :errorHave="true"
            :errorText="errorText1"
            :errorFlag="checkErrorFlag1"
            marginTop="0px"
            :value="address"
            @onchanges="certificateTypeInputChange"
            newStyleFormat
          />
          <c-button
            type="solid"
            :big="true"
            :disabled="kycStep1Disabled"
            marginTop="18px"
            height="40px"
            width="100%"
            @click="btnLink(1)"
            >{{ $t("personal.idAuth.next") }}
          </c-button>
        </div>
        <div v-if="active === '2'">
          <div class="activeTwo">
            <!-- 证件1 头像面 正面 -->
            <div class="upload1 clearfix">
              <div class="upload1-left a-4-bg a-2-bd clearfix">
                <div class="uploadingClass" v-if="firstPhotoLoading">
                  <c-loading size="34" className="common-button-loading a-12-bd" />
                  <p class="loading-text main-cl">
                    {{ $t("personal.prompt.uploading") }}
                  </p>
                </div>
                <div class="loading-Img main-cl" v-else>
                  <svg-icon icon-class="uploadPhotoIcon"></svg-icon>
                  <p v-if="kycType === '1'">
                    {{
                      firstPhoto
                        ? $t("personal.idAuth.uploadIdCardPositiveAgain")
                        : $t("personal.idAuth.uploadIdCardPositive")
                    }}
                  </p>
                  <p v-else>
                    {{
                      firstPhoto
                        ? $t("personal.idAuth.uploadIdCardPositiveAgain")
                        : $t("personal.idAuth.uploadIdCardPositive")
                    }}
                  </p>
                </div>
                <div class="loading-mc b-2-bg" v-if="firstPhotoImg !== ''">
                  <img :src="firstPhotoImg" class="loading-img" />
                  <div class="b-2-bg"></div>
                </div>
                <c-oldUploadFile
                  className="upload_file"
                  maxSize="8"
                  name="firstPhoto"
                  url="common/upload_img"
                  :isOpenUploadImg="isOpenUploadImg"
                  :expand="[]"
                  imageType="1"
                  @tellMessage="onChangeFileFun"
                  @uploadFinish="uploadFinish"
                >
                </c-oldUploadFile>
              </div>
              <div class="upload1-right clearfix positive"></div>
            </div>
            <!-- 证件1 背面 反面 -->
            <div class="upload2 clearfix">
              <div class="upload2-left a-4-bg a-2-bd clearfix">
                <div class="uploadingClass" v-if="secondPhotoLoading">
                  <c-loading size="34" className="common-button-loading a-12-bd" />
                  <p class="loading-text main-cl">
                    {{ $t("personal.prompt.uploading") }}
                  </p>
                </div>
                <div class="loading-Img main-cl" v-else>
                  <svg-icon icon-class="uploadPhotoIcon"></svg-icon>
                  <p v-if="kycType === '1'">
                    {{
                      secondPhoto
                        ? $t("personal.idAuth.uploadIdCardBackAgain")
                        : $t("personal.idAuth.uploadIdCardBack")
                    }}
                  </p>
                  <p v-else>
                    {{
                      secondPhoto
                        ? $t("personal.idAuth.uploadIdCardBackAgain")
                        : $t("personal.idAuth.uploadIdCardBack")
                    }}
                  </p>
                </div>
                <div class="loading-mc b-2-bg" v-if="secondPhotoImg !== ''">
                  <img :src="secondPhotoImg" class="loading-img" />
                  <div class="b-2-bg"></div>
                </div>
                <c-oldUploadFile
                  className="upload_file"
                  maxSize="8"
                  name="secondPhoto"
                  url="common/upload_img"
                  :isOpenUploadImg="isOpenUploadImg"
                  :expand="[]"
                  imageType="1"
                  @tellMessage="onChangeFileFun"
                  @uploadFinish="uploadFinish"
                >
                </c-oldUploadFile>
              </div>
              <div class="upload2-right clearfix reverse"></div>
              <!-- <div v-else class="upload2-right clearfix" :style="bg1"></div> -->
            </div>
            <!-- 证件2 头像面 正面 -->
            <div class="upload1 upload2 clearfix">
              <div class="upload1-left a-4-bg a-2-bd clearfix">
                <div class="uploadingClass" v-if="thirdPhotoLoading">
                  <c-loading size="34" className="common-button-loading a-12-bd" />
                  <p class="loading-text main-cl">
                    {{ $t("personal.prompt.uploading") }}
                  </p>
                </div>
                <div class="loading-Img main-cl" v-else>
                  <svg-icon icon-class="uploadPhotoIcon"></svg-icon>
                  <p v-if="kycType === '1'">
                    {{
                      thirdPhoto
                        ? $t("personal.idAuth.uploadIdCardPositiveAgain")
                        : $t("personal.idAuth.uploadIdCardPositive2")
                    }}
                  </p>
                  <p v-else>
                    {{
                      thirdPhoto
                        ? $t("personal.idAuth.uploadIdCardPositiveAgain")
                        : $t("personal.idAuth.uploadIdCardPositive2")
                    }}
                  </p>
                </div>
                <div class="loading-mc b-2-bg" v-if="thirdPhotoImg !== ''">
                  <img :src="thirdPhotoImg" class="loading-img" />
                  <div class="b-2-bg"></div>
                </div>
                <c-oldUploadFile
                  className="upload_file"
                  maxSize="8"
                  name="thirdPhoto"
                  url="common/upload_img"
                  :isOpenUploadImg="isOpenUploadImg"
                  :expand="[]"
                  imageType="1"
                  @tellMessage="onChangeFileFun"
                  @uploadFinish="uploadFinish"
                >
                </c-oldUploadFile>
              </div>
              <div class="upload1-right clearfix positive"></div>
            </div>
            <!-- 证件2 背面 反面 -->
            <div class="upload2 clearfix">
              <div class="upload2-left a-4-bg a-2-bd clearfix">
                <div class="uploadingClass" v-if="fourthPhotoLoading">
                  <c-loading size="34" className="common-button-loading a-12-bd" />
                  <p class="loading-text main-cl">
                    {{ $t("personal.prompt.uploading") }}
                  </p>
                </div>
                <div class="loading-Img main-cl" v-else>
                  <svg-icon icon-class="uploadPhotoIcon"></svg-icon>
                  <p v-if="kycType === '1'">
                    {{
                      fourthPhoto
                        ? $t("personal.idAuth.uploadIdCardBackAgain2")
                        : $t("personal.idAuth.uploadIdCardBack2")
                    }}
                  </p>
                  <p v-else>
                    <!-- {{
                      fourthPhoto
                        ? $t("personal.idAuth.uploadPassportBackAgain")
                        : $t("personal.idAuth.uploadPassportBack")
                    }} -->
                    {{
                      fourthPhoto
                        ? $t("personal.idAuth.uploadIdCardBackAgain2")
                        : $t("personal.idAuth.uploadIdCardBack2")
                    }}
                  </p>
                </div>
                <div class="loading-mc b-2-bg" v-if="fourthPhotoImg !== ''">
                  <img :src="fourthPhotoImg" class="loading-img" />
                  <div class="b-2-bg"></div>
                </div>
                <c-oldUploadFile
                  className="upload_file"
                  maxSize="8"
                  name="fourthPhoto"
                  url="common/upload_img"
                  :isOpenUploadImg="isOpenUploadImg"
                  :expand="[]"
                  imageType="1"
                  @tellMessage="onChangeFileFun"
                  @uploadFinish="uploadFinish"
                >
                </c-oldUploadFile>
              </div>
              <div class="upload2-right clearfix reverse"></div>
            </div>
            <!-- 地址 -->
            <div class="upload3 clearfix">
              <div class="upload2-left a-4-bg a-2-bd clearfix">
                <div class="uploadingClass" v-if="fifthPhotoLoading">
                  <c-loading size="34" className="common-button-loading a-12-bd" />
                  <p class="loading-text main-cl">
                    {{ $t("personal.prompt.uploading") }}
                  </p>
                </div>
                <div class="loading-Img main-cl" v-else>
                  <svg-icon icon-class="uploadPhotoIcon"></svg-icon>
                  <p v-if="kycType === '1'">
                    {{
                      fifthPhoto
                        ? $t("personal.idAuth.uploadAddress")
                        : $t("personal.idAuth.uploadAddress")
                    }}
                  </p>
                  <p v-else>
                    {{
                      fifthPhoto
                        ? $t("personal.idAuth.uploadAddress")
                        : $t("personal.idAuth.uploadAddress")
                    }}
                    <!-- {{
                      fifthPhoto
                        ? $t(
                            "personal.idAuth.uploadPassportPersonalPositivAgain"
                          )
                        : $t("personal.idAuth.uploadPassportPersonalPositiv")
                    }} -->
                  </p>
                </div>
                <div class="loading-mc" v-if="fifthPhotoImg !== ''">
                  <img :src="fifthPhotoImg" class="loading-img" />
                  <div class="b-2-bg"></div>
                </div>
                <c-oldUploadFile
                  className="upload_file"
                  maxSize="8"
                  name="fifthPhoto"
                  url="common/upload_img"
                  :isOpenUploadImg="isOpenUploadImg"
                  :expand="[]"
                  :isWaterMark="true"
                  imageType="1"
                  @tellMessage="onChangeFileFun"
                  @uploadFinish="uploadFinish"
                >
                </c-oldUploadFile>
              </div>
              <div class="upload2-right clearfix shuidiantuUrl"></div>
            </div>
            <!-- 手持照 -->
            <div class="upload3 clearfix">
              <div class="upload2-left a-4-bg a-2-bd clearfix">
                <div class="uploadingClass" v-if="sixthPhotoLoading">
                  <c-loading size="34" className="common-button-loading a-12-bd" />
                  <p class="loading-text main-cl">
                    {{ $t("personal.prompt.uploading") }}
                  </p>
                </div>
                <div class="loading-Img main-cl" v-else>
                  <svg-icon icon-class="uploadPhotoIcon"></svg-icon>
                  <p v-if="kycType === '1'">
                    {{
                      sixthPhoto
                        ? $t("personal.idAuth.uploadIdCardPersonalPositivAgain")
                        : $t("personal.idAuth.uploadIdCardPersonalPositiv")
                    }}
                  </p>
                  <p v-else>
                    {{
                      sixthPhoto
                        ? $t("personal.idAuth.uploadPassportPersonalPositivAgain")
                        : $t("personal.idAuth.uploadPassportPersonalPositiv")
                    }}
                  </p>
                </div>
                <div class="loading-mc" v-if="sixthPhotoImg !== ''">
                  <img :src="sixthPhotoImg" class="loading-img" />
                  <div class="b-2-bg"></div>
                </div>
                <c-oldUploadFile
                  className="upload_file"
                  maxSize="8"
                  name="sixthPhoto"
                  url="common/upload_img"
                  :isOpenUploadImg="isOpenUploadImg"
                  :expand="[]"
                  :isWaterMark="true"
                  imageType="1"
                  @tellMessage="onChangeFileFun"
                  @uploadFinish="uploadFinish"
                >
                </c-oldUploadFile>
              </div>
              <div class="upload2-right clearfix handheld"></div>
            </div>
            <div class="upload-text2 clearfix">
              <p>1、{{ $t("personal.idAuth.uploadText")[0] }}</p>
              <p>2、{{ $t("personal.idAuth.uploadText")[1] }}</p>
              <p>3、{{ $t("personal.idAuth.uploadText")[2] }}</p>
              <p v-if="kycMetaText.length">4、{{ kycMetaText }}</p>
              <p v-else>4、{{ $t("personal.idAuth.uploadText")[3] }}</p>
              <p>5、{{ $t("personal.idAuth.uploadText")[4] }}</p>
              <p
                v-if="
                  $t('personal.idAuth.uploadText')[5] && $t('personal.idAuth.uploadText')[5].trim()
                "
              >
                6、{{ $t("personal.idAuth.uploadText")[5] }}
              </p>
            </div>
            <c-button
              type="solid"
              :big="true"
              className=""
              paddingW="0px"
              :loading="loading"
              :disabled="disabled2"
              marginTop="24px"
              height="40px"
              width="676px"
              @click="btnLink(2)"
              >{{ $t("personal.tool.submit") }}</c-button
            >
          </div>
        </div>
        <div v-if="active === '3'">
          <div class="audit-information">
            <svg class="icon icon-50" aria-hidden="true">
              <use xlink:href="#icon-g_3"></use>
            </svg>
            <p>{{ $t("personal.idAuth.wait")[0] }} <br />{{ $t("personal.idAuth.wait")[1] }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import countryMinix from 'BlockChain-ui-privatization/PC/common-mixin/countryList/countryList';

export default {
  name: 'bindEmail',
  mixins: [countryMinix],
  data() {
    return {
      promptTextType: this.$t('personal.idAuth.promptTextType'),
      promptText: this.$t('personal.label.promptText'),
      errorText: this.$t('personal.label.errorText'),
      authLevel: 3,
      text1: this.$t('personal.label.idCard'),
      text2: this.$t('personal.label.passport'),
      loading: false,

      promptText1: this.$t('personal.label.promptText1'),

      firstPhotoImg: '',
      secondPhotoImg: '',
      thirdPhotoImg: '',
      fourthPhotoImg: '',
      fifthPhotoImg: '',
      sixthPhotoImg: '',

      firstPhotoLoading: false,
      secondPhotoLoading: false,
      thirdPhotoLoading: false,
      fourthPhotoLoading: false,
      fifthPhotoLoading: false,
      sixthPhotoLoading: false,

      checkValue1: '', // 证件号
      // promptText1: this.$t('personal.label.idCardNum'),
      errorText1: '',
      checkErrorFlag1: false,
      checkValue2: '', // 姓名
      promptText2: this.$t('personal.label.name'),
      active: '1',
      disabled2: true,
      country: '', // 国家编号
      countryErrorFlag: false,
      certificateType: 2, // 证件类型
      certificateTypeErrorFlag: false,
      imageType: '1',
      firstPhoto: '', // 身份证正面
      secondPhoto: '', // 身份证反面
      thirdPhoto: '', // 手持证件
      fourthPhoto: '',
      fifthPhoto: '',
      sixthPhoto: '',
      uploadName: '', // 当前选中的上传模块
      kycPhone: '', // kyc选择的国家
      kycPhoneCode: '',
      kycName: '', // kyc 外国 - 名
      kycFamilyName: '', // kyc 外国 - 姓
      kycMetaText: '', // 上传图片说明文案
      flag: false, // 二维码

      certificateType1: '', // 证件类型1
      certificateType2: '', // 证件类型2
      certificateType1PromptText: `${this.$t('personal.kyc.type')}1(${this.$t(
        'personal.kyc.require',
      )})`, // 证件类型1 label文本
      certificateType2PromptText: `${this.$t('personal.kyc.type')}2(${this.$t(
        'personal.kyc.Optional',
      )})`, // 证件类型2 label文本
      certificateType1NumPromptText: '', // 证件号码1 label文本
      certificateType2NumPromptText: '', // 证件号码2 label文本
      certificateType1Value: '', // 证件号码1 内容
      certificateType2Value: '', // 证件号码2 内容
      address: '', // 地址
      // type1: '护照',
      // type2: '驾照',
      // type3: '身份证',
      // type4: '其他合法证件',
      name: `${this.$t('personal.kyc.name')}(${this.$t('personal.kyc.require')})`,
      fName: `${this.$t('personal.kyc.fName')}(${this.$t('personal.kyc.require')})`,
      idAuthType: [
        // 证件类型枚举
        {
          code: 1,
          value: this.$t('personal.kyc.type1'),
        },
        {
          code: 2,
          value: this.$t('personal.kyc.type2'),
        },
        {
          code: 3,
          value: this.$t('personal.kyc.type3'),
        },
        {
          code: 4,
          value: this.$t('personal.kyc.type4'),
        },
      ],
      certificateType1Options: [
        // 证件类型枚举
        {
          code: 1,
          value: this.$t('personal.kyc.type1'),
        },
        {
          code: 2,
          value: this.$t('personal.kyc.type2'),
        },
        {
          code: 3,
          value: this.$t('personal.kyc.type3'),
        },
        {
          code: 4,
          value: this.$t('personal.kyc.type4'),
        },
      ],
      certificateType2Options: [
        // 证件类型枚举
        {
          code: 1,
          value: this.$t('personal.kyc.type1'),
        },
        {
          code: 2,
          value: this.$t('personal.kyc.type2'),
        },
        {
          code: 3,
          value: this.$t('personal.kyc.type3'),
        },
        {
          code: 4,
          value: this.$t('personal.kyc.type4'),
        },
      ],
    };
  },
  watch: {
    interfaceSwitch(v) {
      if (v) {
        this.getLang();
      }
    },
    userInfo(v) {
      if (v) {
        this.authLevel = this.userInfo.authLevel;
        if (this.authLevel === 2 || this.authLevel === 3) {
          this.active = '1';
        } else if (this.authLevel === 0) {
          this.active = '3';
        } else {
          // this.authLevel为1 审核通过
          this.$router.push('/personal/userManagement');
        }
      }
    },
    publicInfo(v) {
      if (v) {
        this.isOpenUploadImg = this.publicInfo.switch.is_open_upload_img;
      }
    },
    authRealname(authRealname) {
      if (authRealname !== null) {
        this.loading = false;
        if (authRealname.text === 'success') {
          this.$bus.$emit('tip', { text: authRealname.msg, type: 'success' });
          this.active = '3';
          this.$store.dispatch('resetType');
        } else {
          this.$bus.$emit('tip', { text: authRealname.msg, type: 'error' });

          this.firstPhotoImg = '';
          this.secondPhotoImg = '';
          this.thirdPhotoImg = '';
          this.fourthPhotoImg = '';
          this.fifthPhotoImg = '';
          this.sixthPhotoImg = '';

          this.firstPhotoLoading = false;
          this.secondPhotoLoading = false;
          this.thirdPhotoLoading = false;

          this.checkValue1 = '';
          this.checkValue2 = '';

          this.disabled2 = true;
          this.active = '1';

          this.firstPhoto = '';
          this.secondPhoto = '';
          this.thirdPhoto = '';
          this.fourthPhoto = '';
          this.fifthPhoto = '';
          this.sixthPhoto = '';

          this.uploadName = '';
          this.kycName = '';
          this.kycFamilyName = '';
          this.$store.dispatch('resetType');
        }
      }
    },
    appDownload(v) {
      if (v) {
        this.flag = true;
      }
    },
  },
  computed: {
    interfaceSwitch() {
      return this.$store.state.baseData.interfaceSwitch;
    },
    appAuthOpen() {
      return this.$store.state.baseData.app_auth_open;
    },
    publicInfo() {
      return this.$store.state.baseData.publicInfo;
    },
    // bg1() {
    //   if (this.kycType === '1') {
    //     return { backgroundImage: `url(${upload1})` };
    //   }
    //   return {
    //     backgroundImage: `url(${upload5})`,
    //   };
    // },
    // bg2() {
    //   if (this.kycType === '1') {
    //     return {
    //       backgroundImage: `url(${upload2})`,
    //     };
    //   }
    //   return {
    //     backgroundImage: `url(${upload4})`,
    //   };
    // },
    // bg3() {
    //   if (this.kycType === '1') {
    //     return {
    //       backgroundImage: `url(${upload3})`,
    //     };
    //   }
    //   return {
    //     backgroundImage: `url(${upload6})`,
    //   };
    // },
    authRealname() {
      return this.$store.state.personal.authRealname;
    },
    userInfo() {
      return this.$store.state.baseData.userInfo;
    },
    activeP1() {
      if (this.active === '1') {
        return 'main-cl';
      }
      return '';
    },
    activeP2() {
      if (this.active === '2') {
        return 'main-cl';
      }
      return '';
    },
    activeP3() {
      if (this.active === '3') {
        return 'main-cl';
      }
      return '';
    },
    // kyc第一步骤
    kycStep1Disabled() {
      let flag = true;
      // console.log('into');
      if (
        this.kycNationality // 国籍
        && this.certificateType1 // 证件类型1
        && this.certificateType1Value // 证件类型1 value
        && this.kycName // 名
        && this.kycFamilyName // 姓
        // && this.address // 地址
      ) {
        // 证件号码
        flag = false;
      }
      return flag;
    },
    // 国籍
    kycNationality() {
      let str = '';
      const current = this.countryRealMap[`+${this.kycPhone}`];
      if (this.kycPhone && current) {
        const val = current.value;
        [str] = val.split(' +');
      }
      return str;
    },
    // 验证类型 1为中国人 2为外国人
    kycType() {
      if (this.kycPhone) {
        if (this.kycPhone === '156') {
          return '1';
        }
        return '2';
      }
      return '2';
    },
    appDownload() {
      return this.$store.state.baseData.app_download;
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (this.$route.query) {
        if (this.$route.query.country) {
          this.kycPhone = this.$route.query.country;
          this.kycPhoneCode = this.$route.query.countryKeyCode;
        } else if (this.$route.query.countryKeyCode) {
          this.kycPhone = this.countryMap[`+${this.$route.query.countryKeyCode}`].code.replace(
            '+',
            '',
          );
          this.kycPhoneCode = this.$route.query.countryKeyCode;
        } else {
          this.kycPhone = '156';
          this.kycPhoneCode = '86';
        }
      }
      if (this.publicInfo !== null) {
        this.isOpenUploadImg = this.publicInfo.switch.is_open_upload_img;
      }
      if (this.userInfo) {
        this.authLevel = this.userInfo.authLevel;
        if (this.authLevel === 2 || this.authLevel === 3) {
          this.active = '1';
        } else if (this.authLevel === 0) {
          this.active = '3';
        } else {
          // this.authLevel为1 审核通过
          this.$router.push('/personal/userManagement');
        }
      }
      if (this.interfaceSwitch) {
        this.getLang();
      }
    },
    getLang() {
      this.axios({
        url: '/kyc/Api/getUploadImgCopywriting',
      }).then((data) => {
        if (data.code.toString() === '0') {
          if (data.data.language) {
            this.kycMetaText = data.data.language;
          }
        } else {
          this.$bus.$emit('tip', { text: data.msg, type: 'error' });
        }
      });
    },
    certificateType1Change({ code }) {
      this.certificateType1 = code;
      this.certificateType2Options = this.idAuthType.filter(
        item => item.code !== this.certificateType1,
      );
      this.idAuthType.forEach((item) => {
        if (item && item.code === code) {
          this.certificateType1NumPromptText = this.$t(`personal.kyc.value${code}`);
        }
      });
    },
    certificateType2Change({ code }) {
      this.certificateType2 = code;
      this.certificateType1Options = this.idAuthType.filter(
        item => item.code !== this.certificateType2,
      );
      this.idAuthType.forEach((item) => {
        if (item && item.code === code) {
          this.certificateType2NumPromptText = this.$t(`personal.kyc.value${code}`);
        }
      });
    },
    certificateTypeInputChange(value, name) {
      this[name] = value;
    },
    idAuthTypeChange({ code }) {
      this.certificateType = code;
    },
    uploadFinish(obj) {
      if (obj.name) {
        this.uploadName = obj.name;
      }
      if (obj.error) {
        this.$bus.$emit('tip', { text: obj.error, type: 'error' });
        return;
      }
      this[`${this.uploadName}Img`] = obj.url;
      this[`${this.uploadName}Loading`] = false;
      this[this.uploadName] = obj.fileName;
      if (
        this.firstPhotoImg
        // && this.secondPhotoImg
        // && this.thirdPhotoImg
        // && this.fourthPhotoImg
        // && this.fifthPhotoImg
        // && this.sixthPhotoImg
      ) {
        this.disabled2 = false;
      }
    },
    onChangeFileFun(obj) {
      if (obj.code && obj.code === 'maxSize') {
        this.$bus.$emit('tip', { text: this.$t('personal.exccAuthForm.text3'), type: 'error' });
      }
      this.uploadName = obj.name;
      this[`${this.uploadName}Loading`] = true;
    },
    inputChanges(value, name) {
      // 中国 - 姓名
      if (name === 'name') {
        this.checkValue2 = value;
        // 外国 - 姓
      } else if (name === 'kycFamilyName') {
        this.kycFamilyName = value;
        // 外国 - 名
      } else if (name === 'kycName') {
        this.kycName = value;
        // 证件号码
      } else {
        this.checkValue1 = value;
      }
    },
    checkFocus(name) {
      switch (name) {
        case 'email': {
          // email
          this.checkErrorFlag1 = false;
          this.errorText1 = '';
          break;
        }
        case '2': {
          // emailCode
          break;
        }
        default: {
          // newpassword again
        }
      }
    },
    btnLink(num) {
      if (num === 1) {
        this.active = '2';
      } else {
        this.loading = true;
        const datas = {};
        datas.info = {
          countryCode: `+${this.kycPhoneCode}`, // 电话编码
          numberCode: this.kycPhone, // 国家代码
          // certificateType: type, // 证件类型
          // certificateNumber: this.checkValue1, // 证件号
          userName: this.checkValue2 || '', // 中国 - 姓名
          // firstPhoto: this.firstPhoto,
          // secondPhoto: this.secondPhoto,
          // thirdPhoto: this.thirdPhoto,
          familyName: this.kycFamilyName || '', // 外国姓
          name: this.kycName || '', // 外国名

          certificateNumber: this.certificateType1Value || '', // 证件1号码
          certificateType: this.certificateType1 || '', // 证件类型 1
          firstPhoto: this.firstPhoto || '', // 证件1正面
          secondPhoto: this.secondPhoto || '', // 证件1背面

          certificateNumber2: this.certificateType2Value || '', // 证件2号码
          certificateType2: this.certificateType2 || '', // 证件2类型
          thirdPhoto: this.thirdPhoto || '', // 证件2正面
          fourthPhoto: this.fourthPhoto || '', // 证件2背面

          fifthPhoto: this.fifthPhoto || '', // 地址证明
          sixthPhoto: this.sixthPhoto || '', // 手持签名

          address: this.address || '', // 地址
        };
        this.$store.dispatch('authRealname', datas);
      }
    },
  },
};
</script>

<style lang="scss" scss>
.user-management-id-auth {
  width: 100%;
  min-height: 800px;

  .user-management-child-header {
    font-size: 14px;
    padding: 18px 0 18px 20px;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    box-sizing: border-box;
  }

  .user-management-center i {
    width: 14px;
  }

  .certification-process {
    margin: 24px;
    position: relative;
    text-align: center;
  }

  .certification-process div p {
    font-size: 14px;
    line-height: 24px;
  }

  .step-left {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    padding-right: 50px;
  }

  .step-center {
    display: inline-block;
    position: relative;
    z-index: 2;
    padding: 0 50px;
  }

  .step-right {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
    padding-left: 50px;
  }

  .certification-process .div-line {
    width: 100%;
    position: absolute;
    left: 0;
    top: 11px;
    border-bottom-width: 2px;
    border-bottom-style: dashed;
    z-index: 1;
  }

  .span-mark {
    float: left;
    width: 24px;
    height: 24px;
    border-radius: 4px;
    font-size: 12px;
    text-align: center;
    line-height: 24px;
    margin-right: 10px;
  }

  .idAuth-center {
    padding-bottom: 24px;

    .activeOne {
      width: 447px;
      margin: 0 auto;
    }

    .activeTwo {
      width: 676px;
      margin: 0 auto;
    }

    /deep/ .input-line-label {
      font-size: 12px;
    }
  }

  .upload1,
  .upload2,
  .upload3 {
    display: flex;
    justify-content: center;
    gap: 24px;
  }

  .upload1 div.upload1-left,
  .upload2 div.upload2-left,
  .upload3 div.upload2-left,
  .upload1 div.upload1-right,
  .upload2 div.upload2-right,
  .upload3 div.upload2-right {
    width: 320px;
    height: 180px;
    flex: 1;
    // box-sizing: border-box;
    border-radius: 4px;
    background-size: cover;
  }

  .positive {
    background-image: url(~@/assets/img/positive.png);
  }

  .reverse {
    background-image: url(~@/assets/img/reverse.png);
  }

  .handheld {
    background-image: url(~@/assets/img/handheld.png);
  }

  .shuidiantuUrl {
    background-image: url(~@/assets/img/shuidiantuUrl.png);
  }

  .upload1 div.upload1-left,
  .upload2 div.upload2-left,
  .upload3 div.upload2-left {
    border-width: 1px;
    border-style: dashed;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    background-image: url('~@/assets/img/uploadbg.png');
    background-size: 100% 100%;

    svg {
      margin: 40px 78px 10px 78px;
    }

    p {
      font-size: 12px;
      text-align: center;
    }

    .mmd-loading-circle-right,
    .mmd-loading-circle-left {
      border-color: rgba(27, 170, 236, 1);
    }

    .loading-Img {
      position: absolute;
      z-index: 2;
      width: 194px;
      margin: 0 auto;
      height: 100%;
      text-align: center;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      svg {
        font-size: 40px;
      }

      p {
        margin-top: 20px;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
      }
    }

    .loading-img {
      width: 100%;
      height: 100%;
      margin: 0;
    }

    .loading-mc {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;

      div {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0.7;
      }
    }
  }

  .upload2,
  .upload3 {
    margin-top: 20px;
  }

  .upload-text1 {
    float: left;
    font-size: 12px;
    margin: 24px 0;
    line-height: 18px;
  }

  .upload-text2 {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    text-align: justify;
    margin: 0 auto;
    margin-top: 40px;
  }

  .upload_file {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    cursor: pointer;
    z-index: 3;
  }

  .uploadingClass {
    position: absolute;
    width: 100%;
    height: 100%;
    text-align: center;
    padding-top: 40px;

    .common-button-loading {

    }

    .loading-text {
      font-size: 14px;
      margin-top: 20px;
    }
  }

  .audit-information {
    text-align: center;

    svg {
      margin: 80px 0 15px 0;
    }
  }

  .audit-information p {
    font-size: 12px;
    line-height: 20px;
    text-align: center;
  }
  .goAppAuth {
    width: 447px;
    margin: 0 auto;
    padding-top: 20px;
    .goAppAuthNote {
      margin-bottom: 20px;
      margin-top: 20px;
    }
    .qrCode {
      overflow: hidden;
      img {
        width: 100px;
        height: 100px;
        float: left;
        margin-right: 20px;
      }
      div {
        float: left;
        height: 100px;
        line-height: 100px;
      }
    }
    .exImg {
      img {
        width: 100%;
      }
    }
  }
}
</style>
